import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import getLang from 'I18n/utils/getLang';
import Raven from 'raven-js';
import UIButton from 'UIComponents/button/UIButton';
import { useRemoveFromPlaylist } from '../../savedItems';

const RemoveItemFromPlaylistButton = (_ref) => {
  let {
    children,
    itemId,
    playlistId,
    itemType,
    language = getLang(),
    onSuccess,
    showNotification = true,
    onClick,
    use = 'unstyled'
  } = _ref,
      buttonProps = _objectWithoutPropertiesLoose(_ref, ["children", "itemId", "playlistId", "itemType", "language", "onSuccess", "showNotification", "onClick", "use"]);

  const [removeFromPlaylist, {
    removeFromPlaylistMutationLoading
  }] = useRemoveFromPlaylist({
    showNotification
  });

  const handleOnClick = e => {
    if (removeFromPlaylistMutationLoading) return;
    if (onClick) onClick(e);
    removeFromPlaylist({
      playlistId,
      itemId,
      language,
      type: itemType
    }).then(onSuccess).catch(() => {
      Raven.captureMessage(`Achievements: error removing item from playlist`, {
        extra: {
          playlistId,
          itemId,
          language,
          itemType
        }
      });
    });
  };

  return /*#__PURE__*/_jsx(UIButton, Object.assign({}, buttonProps, {
    onClick: handleOnClick,
    use: use,
    children: children
  }));
};

export default RemoveItemFromPlaylistButton;